/**
 * Generates a strong random password that meets ICSC BOSS password policy:
 * - At least 12 characters
 * - Uppercase, lowercase, digit, special character
 * - No sequential characters (abc, 123)
 * - Varied every time
 */

const UPPER  = 'ABCDEFGHJKLMNPQRSTUVWXYZ';   // no I, O (confusing)
const LOWER  = 'abcdefghjkmnpqrstuvwxyz';     // no i, l, o
const DIGITS = '23456789';                    // no 0, 1 (confusing)
const SPECIAL = '@#$%^&*!?';

function pick(charset) {
  return charset[Math.floor(Math.random() * charset.length)];
}

function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export function generatePassword(length = 14) {
  // Guarantee at least one of each required type
  const required = [
    pick(UPPER),
    pick(UPPER),
    pick(LOWER),
    pick(LOWER),
    pick(DIGITS),
    pick(DIGITS),
    pick(SPECIAL),
  ];

  const all = UPPER + LOWER + DIGITS + SPECIAL;
  const rest = Array.from({ length: length - required.length }, () => pick(all));

  return shuffle([...required, ...rest]).join('');
}
